/**
 * Appearance follows the system until someone chooses Light or Dark.
 * A stored "dark" value is treated as that choice. "light" used to be
 * written on every visit, so it is not a choice unless theme choice is set.
 */

const THEME_KEY = 'pacarion_theme';
const THEME_CHOICE_KEY = 'pacarion_theme_choice';

function systemPrefersDark(matchMedia) {
  if (typeof matchMedia !== 'function') return false;
  try {
    return matchMedia('(prefers-color-scheme: dark)').matches === true;
  } catch (error) {
    return false;
  }
}

function explicitTheme(storage) {
  if (!storage) return null;
  const choice = storage.getItem(THEME_CHOICE_KEY);
  if (choice === 'dark' || choice === 'light') return choice;
  if (storage.getItem(THEME_KEY) === 'dark') return 'dark';
  return null;
}

function themeIsDark(storage, matchMedia) {
  const choice = explicitTheme(storage);
  if (choice === 'dark') return true;
  if (choice === 'light') return false;
  return systemPrefersDark(matchMedia);
}

function rememberThemeChoice(storage, isDark) {
  const value = isDark ? 'dark' : 'light';
  storage.setItem(THEME_KEY, value);
  storage.setItem(THEME_CHOICE_KEY, value);
}

/** Drop Light/Dark so the next paint follows the system again. */
function clearThemeChoice(storage) {
  if (!storage || typeof storage.removeItem !== 'function') return;
  storage.removeItem(THEME_CHOICE_KEY);
  storage.removeItem(THEME_KEY);
}

function appearanceMode(storage) {
  return explicitTheme(storage) || 'system';
}

module.exports = {
  THEME_KEY,
  THEME_CHOICE_KEY,
  systemPrefersDark,
  explicitTheme,
  themeIsDark,
  rememberThemeChoice,
  clearThemeChoice,
  appearanceMode,
};
